import { filter, fromEvent } from "rxjs";
import { getComponentElement } from "./baseComponent.helpers";
import { CdpaTooltip } from "./cdpaTooltip.component";
import { HTMLElementAttribute, HTMLElementEventType } from "./misc.enums";
import { sendInteractionMetrics } from "../../login/src/formHelpers/metricsHelper";
import { UIType } from "./cdpaRequest";
export var CdpaButtonId;
(function (CdpaButtonId) {
    CdpaButtonId["Login"] = "log-in-button";
    CdpaButtonId["LoginVerifyEmail"] = "send-link-button";
    CdpaButtonId["Continue"] = "continue-button";
    CdpaButtonId["Register"] = "register-button";
    CdpaButtonId["EmailCodeLogin"] = "email-code-login";
    CdpaButtonId["EmailCodeResend"] = "email-code-resend";
    CdpaButtonId["ConfirmIdp"] = "confirm-idp-button";
    CdpaButtonId["SendEmail"] = "send-email-button";
    CdpaButtonId["DeleteAccountConfirm"] = "delete-account-confirm-button";
    CdpaButtonId["DeleteAccountFinalConfirm"] = "delete-account-final-confirm";
    CdpaButtonId["DeleteAccountCancel"] = "delete-account-cancel";
    CdpaButtonId["DeleteAccountModalCancel"] = "delete-account-modal-cancel";
    CdpaButtonId["UpdateEmailConfirm"] = "update-email-confirm";
    CdpaButtonId["LoginGrantAccept"] = "login-grant-accept";
    CdpaButtonId["LoginGrantDeny"] = "login-grant-deny";
    CdpaButtonId["LinkDeviceAccept"] = "link-device-account-accept";
    CdpaButtonId["LinkDeviceDeny"] = "link-device-account-deny";
    CdpaButtonId["LinkDeviceChangeAccount"] = "link-device-account-change-account";
    CdpaButtonId["LoginConfirmation"] = "confirm-login-button";
    CdpaButtonId["DeviceCode"] = "device-code-login";
    CdpaButtonId["TryAgain"] = "try-again-button";
})(CdpaButtonId || (CdpaButtonId = {}));
var CdpaButtonQuerySelector;
(function (CdpaButtonQuerySelector) {
    CdpaButtonQuerySelector["Label"] = ".cdpa-button__label";
    CdpaButtonQuerySelector["Spinner"] = ".cdpa-button__spinner";
    CdpaButtonQuerySelector["Tooltip"] = ".cdpa-tooltip";
})(CdpaButtonQuerySelector || (CdpaButtonQuerySelector = {}));
var CdpaButtonClassModifier;
(function (CdpaButtonClassModifier) {
    CdpaButtonClassModifier["Loading"] = "cdpa-button--loading";
    CdpaButtonClassModifier["Disabled"] = "cdpa-button--disabled";
})(CdpaButtonClassModifier || (CdpaButtonClassModifier = {}));
export class CdpaButtonComponent {
    constructor(elementId) {
        this.buttonElement = getComponentElement(document.getElementById(elementId));
        this.buttonLabel = getComponentElement(this.buttonElement.querySelector(CdpaButtonQuerySelector.Label));
        this.buttonTooltip = new CdpaTooltip(this.buttonElement);
        this.buttonElement.addEventListener("click", () => {
            sendInteractionMetrics(this.buttonElement, UIType.Button);
            this.buttonElement.blur();
        });
    }
    get isLoading() {
        return this.buttonElement.classList.contains(CdpaButtonClassModifier.Loading);
    }
    set isLoading(value) {
        if (value) {
            this.buttonElement.classList.add(CdpaButtonClassModifier.Loading);
            this.buttonLabel.setAttribute(HTMLElementAttribute.Hidden, "");
        }
        else {
            this.buttonElement.classList.remove(CdpaButtonClassModifier.Loading);
            this.buttonLabel.removeAttribute(HTMLElementAttribute.Hidden);
        }
    }
    setDisabled(isDisabled) {
        if (isDisabled) {
            this.buttonElement.classList.add(CdpaButtonClassModifier.Disabled);
            this.buttonElement.tabIndex = -1;
        }
        else {
            this.buttonElement.classList.remove(CdpaButtonClassModifier.Disabled);
            this.buttonElement.tabIndex = 0;
        }
    }
    get isDisabled() {
        return this.buttonElement.classList.contains(CdpaButtonClassModifier.Disabled);
    }
    get onClick$() {
        return fromEvent(this.buttonElement, HTMLElementEventType.Click).pipe(filter(() => !this.buttonElement.classList.contains(CdpaButtonClassModifier.Disabled)));
    }
    click() {
        this.buttonElement.click();
    }
    setLabel(value) {
        this.buttonLabel.innerText = value;
    }
}
